import { GET_DAY_BUSY_SLOTS } from '@redturtle/volto-io-prenoto/actions/slots';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
};

// Get Day busy slots
export const dayBusySlots = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_DAY_BUSY_SLOTS}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_DAY_BUSY_SLOTS}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_DAY_BUSY_SLOTS}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};
